import storage from './storage';
import { TEAM_KEYS } from '../utils/teamCrmStore';

function key() {
  return TEAM_KEYS.pipeline;
}

export const pipelineService = {
  get(_userId) {
    void _userId;
    return storage.get(key(), null);
  },

  save(_userId, stages) {
    void _userId;
    if (stages === null) {
      storage.remove(key());
    } else {
      storage.set(key(), stages);
    }
  },
};
